module.exports = __webpack_public_path__ + "img/coupon-popup-item-use-hen.5f60305c.png";